import { MessageSquare } from 'lucide-react'
import { useEffect, useState } from 'react'
import { apiClient } from '~/api/client'
import { DataTable } from '~/components/DataTable'
import { PageHeader } from '~/components/PageHeader'
import { Button } from '~/components/ui/button'
import { EmptyState } from '~/components/ui/empty-state'
import { Skeleton } from '~/components/ui/skeleton'
import { useToast } from '~/components/ui/toast'

// 질의응답 히스토리: 검색/필터/내보내기 (DESIGN.md §5.1 /admin/conversations).
interface ConsultationRow {
    id: string
    question: string
    status: string
    createdAt: string | null
}

interface ExportResult {
    downloadUrl: string
    filename: string
    rowCount: number
}

export function ConversationsPage() {
    const toast = useToast()
    const [consultations, setConsultations] = useState<ConsultationRow[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        apiClient
            .get<ConsultationRow[]>('/consultations')
            .then(setConsultations)
            .catch((e) => toast.error((e as Error).message))
            .finally(() => setLoading(false))
    }, [toast])

    const exportExcel = async () => {
        try {
            const result = await apiClient.get<ExportResult>(
                '/exports/conversations'
            )
            window.open(result.downloadUrl, '_blank')
            toast.success(`내보내기 완료 · ${result.rowCount}건`)
        } catch (e) {
            toast.error((e as Error).message)
        }
    }

    return (
        <div>
            <PageHeader
                title='질의응답 히스토리'
                description='세션·상담 검색 · 필터 · 내보내기'
            />
            <div className='mb-3'>
                <Button variant='outline' size='sm' onClick={exportExcel}>
                    Excel 내보내기
                </Button>
            </div>
            {loading ? (
                <div className='space-y-2'>
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Skeleton key={i} className='h-10' />
                    ))}
                </div>
            ) : consultations.length === 0 ? (
                <EmptyState
                    icon={MessageSquare}
                    title='상담 이력이 없어요.'
                    description='사용자 질의응답이 쌓이면 여기에서 검색·내보내기할 수 있어요.'
                />
            ) : (
                <DataTable
                    columns={['질문', '상태', '생성일']}
                    rows={consultations.map((i) => [
                        i.question,
                        i.status,
                        i.createdAt ?? '-',
                    ])}
                    emptyMessage='상담 이력이 없어요.'
                />
            )}
        </div>
    )
}
